export default __webpack_public_path__ + "static/hacktoberfest-prep-2024-extending-meshery-models-4d36a45041f9bd1c48ed8cc232f33224.pdf";